import React, { Fragment, useRef, useState } from 'react'
import { PopoverGroup, Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react'
import { Link, navigate, } from 'gatsby';
import { OutboundLink } from "gatsby-plugin-google-gtag"

export default function DesktopMenu({mainMenu}) {

	const [isShowing, setIsShowing] = useState(null);
	const buttonRefArray = useRef([]);
	const timeoutDuration = 200
	let timeout

	const ctaColours = ['orange', 'moon', 'blue'];

	const onMouseEnter = (idx) => {
		clearTimeout(timeout)
		setIsShowing(idx)
	}

	const onMouseLeave = () => {
		timeout = setTimeout(() => setIsShowing(null), timeoutDuration)
	}

	return (
		<PopoverGroup className="lg:flex lg:gap-x-12">
			{mainMenu && mainMenu.length > 0 ? mainMenu.map(({node}, mIdx) => {
				if (node.Links) {
					return (
						<Popover key={node.id}>
							{({open}) => {
								return (
									<>
										<div onMouseLeave={() => onMouseLeave()} tabIndex={0} role='link'>
											<PopoverButton 
												className="flex cursor-pointer items-center gap-x-1 text-sm font-semibold leading-6 text-white uppercase"
												ref={ref => {
													buttonRefArray.current[mIdx] = ref;
												}}
												onMouseEnter={() => onMouseEnter(mIdx)}
												onClick={() => navigate(node.InternalLink)}
												onKeyDown={() => navigate(node.InternalLink)}
											>
												{node.Section}
											</PopoverButton>
										</div>
										<Transition
											as={Fragment}
											show={isShowing === mIdx && node?.Links?.length > 0}
											enter="transition ease-out duration-200"
											enterFrom="opacity-0"
											enterTo="opacity-100"
											leave="transition ease-in duration-150"
											leaveFrom="opacity-100"
											leaveTo="opacity-0"
										>
											<Popover.Overlay className="fixed inset-0 -z-20 bg-global-700 opacity-40" />
										</Transition>
										<Transition
											as={Fragment}
											show={isShowing === mIdx && node?.Links?.length > 0}
											enter="transition ease-out duration-200"
											enterFrom="opacity-0 -translate-y-1"
											enterTo="opacity-100 translate-y-0"
											leave="transition ease-in duration-150"
											leaveFrom="opacity-100 translate-y-0"
											leaveTo="opacity-0 -translate-y-1"
											onMouseEnter={() => onMouseEnter(mIdx)}
											onMouseLeave={() => onMouseLeave()}
										>	
											<PopoverPanel static className="absolute backdrop-blur-md inset-x-0 top-0 -z-10 bg-global-700/25 mt-[100px] shadow-xl rounded-sm">
												<div 
													className="mx-auto grid max-w-6xl grid-cols-4 px-2 py-8 xl:gap-x-8 border-til-orange"
												>
													<div className=''>
														{node.Links.map((item) => (
															<div key={item.id} className="group relative p-3 rounded-lg hover:bg-global-700/30">
															{ item.InternalLink ?
																<Link to={item.InternalLink} className="block font-semibold text-white text-sm leading-6 uppercase pl-2">
																	{item.Name}
																	<span className="absolute inset-0" />
																</Link>
															   : <OutboundLink href={item.ExternalLink} className="block font-semibold text-white text-sm leading-6 uppercase pl-2">
																	{item.Name}
																	<span className="absolute inset-0" />
																</OutboundLink>
															}
															</div>
														))}
													</div>
													{node.CallToActions.map((item, idx) => {
														return (
															<div key={item.id} className={`mx-1 relative grid h-[210px] bg-white rounded-sm`}>
																<img
																	style={{ gridArea: '1/3', maxHeight: 100}}
																	className='h-full object-cover rounded-t'
																	layout="fullWidth"
																	placeholder="dominantColor"
																	height="100px"
																	alt=""
																	src={item.Image?.formats?.small?.url || item.Image?.formats?.medium?.url || item.Image?.formats?.large?.url}
																/>
																<div className='text-md bold h-[100px] relative' style={{
																	gridArea: "1/3",
																	placeItems: "center",
																}}>
																	<div className="w-full h-full flex  justify-center items-center z-0"
																		style={{
																			borderRadius: 5,
																			opacity: 0.75,
																			background: "linear-gradient(0deg, #000 0%, rgba(0, 0, 56, 0.00) 100%, rgba(0, 0, 2, 0.00) 100%)"
																		}}
																	>
																	</div>
																	<div className="absolute text-white text-lg font-semibold bottom-3 left-3 z-10">{item.Text}</div>
																</div>
																<div style={{gridArea: "2/3"}} className='h-[110px] px-4 pt-2 content-start flex w-full mx-auto align-top text-xs'>
																	{item.Description}
																</div>
																<div style={{gridArea: "3/3"}} className='absolute bottom-0 -ml-4 px-4 flex w-full mx-auto items-center justify-center '>
																{ item.InternalLink ?  
																	<Link
																		to={item.InternalLink}
																		className="w-full items-center justify-center text-xs font-semibold leading-6 uppercase"
																	>
																		<div className={`mx-4 my-2 bg-${ctaColours[idx]}-700 w-full justify-center content-center text-center rounded-full text-white h-8 py-1`}>
																			{item.LinkLabel}
																		</div>
																		
																	</Link>
																  : <a
																		href={item.ExternalLink}
																		className="w-full items-center justify-center text-xs font-semibold leading-6 uppercase"
																	>
																		<div className={`mx-4 my-2 bg-${ctaColours[idx]}-700 w-full justify-center content-center text-center rounded-full text-white h-8 py-1`}>
																			{item.LinkLabel}
																		</div>
																		
																	</a>
																}
																
																</div>
																
															</div>
														)
													})}
												</div>
											</PopoverPanel>
										</Transition>
									</>
								)
							}}
						
						</Popover>
					)
				}
				if (node.InternalLink) {
					return (
						<Link key={node.id} to={node.InternalLink} className="flex items-center gap-x-1 text-sm font-semibold leading-6 text-white uppercase">
							{node.Section}
						</Link>
					)
				} else {
					return (
						<a key={node.id} href={node.ExternalLink} className="flex items-center gap-x-1 text-sm font-semibold leading-6 text-white uppercase">
							{node.Section}
						</a>
					)
				}
				
			}) : null}
        </PopoverGroup>
	)
}